export default defineNuxtRouteMiddleware((to) => {
  const generalStore = useGeneralStore();
  const localePath = useLocalePathPolyfill();

  // Check if viewing someone else's wishlist
  const isViewingSharedWishlist = !!to.query.wishlist_unique_id;

  // Redirect to home if not authenticated and no shared wishlist ID
  if (!generalStore.isAuthenticated && !isViewingSharedWishlist) {
    return navigateTo(localePath("/"));
  }
});
